import "@spectrum-css/tokens/dist/index.css";
import {
  AlertWhite,
  CallbackIcon,
  CallIcon,
  CasesIcon,
  ChatIcon,
  // ChromeNotificationsIcon,
  ContactsIcon,
  CustomResponsesIcon,
  HistoryIcon,
  NotesIcon,
  SearchIcon,
  TemplatesIcon,
  VoicemailIcon,
  WarningIconSidebar,
} from "./../common/Icons";
import "./style.css";
/*
  For components with no other contexts available, load the
  index.css file from the component's package. These are components
  that do not have a spectrum or express context available.
*/
import "@spectrum-css/page/dist/index.css";
import "@spectrum-css/typography/dist/index.css";
import "@spectrum-css/icon/dist/index.css";

/*
  Recommended: For components with multiple contexts available, if you
  want access to all contexts, load the index.css file, which includes
  all contexts and component variables.
*/
import "@spectrum-css/sidenav/dist/index.css";
import { Heading, View, Text, Flex } from "@adobe/react-spectrum";
import { setCurrentSessionTab } from "../../actions/session";
import storeRTK from "../../store/storeRTK";
import { useSelector } from "react-redux";
import { RootState } from "../../store/storeConfig";
import {
  AIC_CONNECTING_MESSAGE,
  CASE_NETWORK_ERROR_MSG,
  CHAT_NETWORK_ERROR_MSG,
  VOICE_NETWORK_DISCONNECT,
} from "../../constants/common";
import { useCallback, useEffect, useMemo, useState } from "react";
import Emitter from "../../emitter";
import { CHAT_UNREAD_MSG_SIDEBAR } from "../../constants/events";
import { CHAT } from "../../constants/constants";

const mySpaceItems = [
  { key: "notes", icon: <NotesIcon color={"#000000"} />, label: "Notes" },
  {
    key: "speedDial",
    icon: <ContactsIcon color={"#000000"} />,
    label: "Speed Dials",
  },
  {
    key: "history",
    icon: <HistoryIcon color={"#d6d6d6"} />,
    label: "History",
    isDisabled: true,
  },
  {
    key: "kb_search",
    icon: <SearchIcon color={"#d6d6d6"} />,
    label: "KB Search",
    isDisabled: true,
  },
  {
    key: "templates",
    icon: <TemplatesIcon color={"#d6d6d6"} />,
    label: "Templates",
    isDisabled: true,
  },
  {
    icon: <CustomResponsesIcon color={"#d6d6d6"} />,
    label: "Custom Responses",
    isDisabled: true,
  },
];

const CountBadge = ({
  count,
  isSelected,
}: {
  count: number;
  isSelected?: boolean;
}) => (
  <span
    style={{
      color: "#222222",
      borderRadius: "50%",
      fontSize: "0.75rem",
      backgroundColor: isSelected ? "#FFFFFF" : "#E6E6E6",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "20px",
      height: "20px",
      textAlign: "center",
    }}
  >
    {count}
  </span>
);

// const ChromeNotificationsBanner = () => (
//   <View
//     width={"10%"}
//     position={"absolute"}
//     padding={"8px"}
//     borderRadius={"medium"}
//     alignSelf={"center"}
//     borderWidth={"thin"}
//     borderColor={"red-400"}
//     zIndex={10}
//     marginTop={"5rem"}
//   >
//     <Flex alignItems="center" gap="size-100">
//       <div
//         style={{
//           position: "relative",
//           fontSize: "16px",
//           color: "#E34850",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//         }}
//       >
//         <ChromeNotificationsIcon />
//       </div>
//       <Text UNSAFE_className="chrome_notifications_off_msg">
//         Chrome notifications are off
//       </Text>
//     </Flex>
//   </View>
// );


const ErrorMessage = ({ message }: { message: string }) => (
  <View
    width={"10%"}
    position={"absolute"}
    bottom={"size-0"}
    padding={"8px"}
    backgroundColor={"red-400"}
    borderRadius={"medium"}
    alignSelf={"center"}
    marginBottom={"size-100"}
    zIndex={5}
  >
    <AlertWhite />
    <br />
    <Text UNSAFE_className="vpn_err_msg">{message}</Text>
  </View>
);

const SiderBar = () => {
  const currentTab = useSelector(
    (state: RootState) => state.session.currentTab
  );
  const sessionError = useSelector(
    (state: RootState) => state.session.sessionError
  );
  const ccpSessionState = useSelector(
    (state: RootState) => state.webrtc.ccpSessionState
  );
  const isVoiceNetworkAvailable = useSelector(
    (state: RootState) => state.webrtc.isVoiceNetworkAvailable
  );
  const isVPNCheckCompletedAfterLogin = useSelector(
    (state: RootState) => state.webrtc.isVPNCheckCompletedAfterLogin
  );

  const common = useSelector((state: RootState) => state.common);
  const call = useSelector((state: RootState) => state.call);
  const callback = useSelector((state: RootState) => state.callback);
  const chat = useSelector((state: RootState) => state.chat);
  const voicemail = useSelector((state: RootState) => state.voicemail);
  const cases = useSelector((state: RootState) => state.cases);
  const [newChatAlert, setNewChatAlert] = useState(false);
  // const [showChromeNotificationsBanner, setShowChromeNotificationsBanner] =
  //   useState(false);

  useEffect(() => {
    if (currentTab !== CHAT && common.tab !== "Chats") {
      Emitter.on(CHAT_UNREAD_MSG_SIDEBAR, showChatRedDot);
    }
    return () => {
      Emitter.off(CHAT_UNREAD_MSG_SIDEBAR, showChatRedDot);
    };
  }, [currentTab, common.tab]);

  // useEffect(() => {
  //   // Check notification permission status
  //   if ("Notification" in window) {
  //     setShowChromeNotificationsBanner(Notification.permission === "denied");
  //   }
  // }, []);

  const showChatRedDot = () => {
    setNewChatAlert(true);
  };

  const changeTab = useCallback((id: string) => {
    storeRTK.dispatch(setCurrentSessionTab({ id }));
    id === CHAT && setNewChatAlert(false);
  }, []);

  const shouldShowWarning = useMemo(() => {
    return (
      ccpSessionState !== 4 || !navigator.onLine || !isVoiceNetworkAvailable
    );
  }, [ccpSessionState, isVoiceNetworkAvailable, navigator.onLine]);

  const channelItems = useMemo(
    () => [
      {
        key: "call",
        icon: <CallIcon />,
        label: "Call",
        showWarning: true,
        count: call.id ? 1 : 0,
      },
      {
        key: "callback",
        icon: <CallbackIcon />,
        label: "Callback",
        count: callback.id ? 1 : 0,
      },
      {
        key: "voicemail",
        icon: <VoicemailIcon color="#000000" />,
        label: "Voicemail",
        count: voicemail.id ? 1 : 0,
      },
      {
        key: "chat",
        icon: <ChatIcon color="#000000" />,
        label: "Chat",
        count: chat.chats?.length ?? 0,
      },
      {
        key: "case",
        icon: <CasesIcon color="#000000" />,
        label: "Case",
        count: cases.cases?.length ?? 0,
      },
    ],
    [
      call.id,
      callback.id,
      voicemail.id,
      chat.chats?.length,
      cases.cases?.length,
    ]
  );

  return (
    <div
      data-html-preview=""
      className="spectrum spectrum--light spectrum--medium spectrum--express"
      style={{
        margin: "12.6% 12.6% 15% 12.6%",
        backgroundColor: "#F8F8F8",
      }}
    >
      <Heading level={4} UNSAFE_style={{ paddingLeft: "calc(1rem - 1px)" }}>
        Channels
      </Heading>
      <nav>
        <ul
          className="spectrum-SideNav spectrum-SideNav--hasIcon"
          style={{ fontSize: "1rem" }}
        >
          {channelItems.map((item) => (
            <li
              key={item.key}
              className={`sidebar-content spectrum-SideNav-item ${item.key}${
                currentTab === item.key ? " is-selected" : ""
              }`}
              onClick={() => changeTab(item.key)}
            >
              {item.icon}
              <Flex alignItems="center" gap="size-100" flexGrow={1}>
                <Text UNSAFE_className="spectrum-SideNav-link-text">
                  {item.label}
                </Text>

                {item.key === "chat" && newChatAlert && (
                  <span className="red-dot" aria-label="New chat message" />
                )}
              </Flex>
              <Flex
                alignItems="center"
                justifyContent="end"
                marginStart="auto"
                gap="size-100"
              >
                {item.showWarning && shouldShowWarning && (
                  <WarningIconSidebar />
                )}

                {item.count > 0 && (
                  <CountBadge
                    count={item.count}
                    isSelected={currentTab === item.key}
                  />
                )}
              </Flex>
            </li>
          ))}
        </ul>
      </nav>
      <Heading level={4} UNSAFE_style={{ paddingLeft: "calc(1rem - 1px)" }}>
        My Space
      </Heading>
      <nav>
        <ul className="spectrum-SideNav spectrum-SideNav--hasIcon">
          {mySpaceItems.map((item, index) => (
            <li
              key={index}
              className={`sidebar-content spectrum-SideNav-item ${item.key}${
                currentTab === item.key ? " is-selected" : ""
              }`}
              onClick={() => {
                if (typeof item.key === "string" && !item.isDisabled) {
                  changeTab(item.key);
                }
              }}
            >
              {item.icon}
              <Text
                UNSAFE_className={`spectrum-SideNav-link-text ${
                  item.isDisabled ? "disable-text" : ""
                }`}
              >
                {item.label}
              </Text>
            </li>
          ))}
        </ul>
      </nav>
      {/* {showChromeNotificationsBanner && <ChromeNotificationsBanner />} */}
      {navigator.onLine &&
        (ccpSessionState !== 4 || !isVPNCheckCompletedAfterLogin) && (
          <ErrorMessage message={AIC_CONNECTING_MESSAGE} />
        )}
      {!navigator.onLine && (
        <ErrorMessage
          message={
            currentTab === "chat"
              ? CHAT_NETWORK_ERROR_MSG
              : currentTab === "case"
              ? CASE_NETWORK_ERROR_MSG
              : sessionError || VOICE_NETWORK_DISCONNECT
          }
        />
      )}
      {navigator.onLine &&
        ccpSessionState == 4 &&
        isVPNCheckCompletedAfterLogin &&
        !isVoiceNetworkAvailable && (
          <ErrorMessage message={sessionError || VOICE_NETWORK_DISCONNECT} />
        )}
    </div>
  );
};

export default SiderBar;
